/**
 * Manages the data-scrolled attribute on the HTML element based on window scroll position
 */

const SCROLL_THRESHOLD = 0;

export const updateScrolledAttribute = (): void => {
  const htmlElement = document.documentElement;

  if (window.scrollY > SCROLL_THRESHOLD) {
    htmlElement.dataset.pageScrolled = "";
  } else {
    delete htmlElement.dataset.pageScrolled;
  }
};

updateScrolledAttribute();

window.addEventListener("scroll", updateScrolledAttribute, { passive: true });
